// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3uxUS","error":"Textarea_error__2wxzi","readonly":"Textarea_readonly__1AYtK","disabled":"Textarea_disabled__xrjtD"};